import { Maybe } from '../../../__generated__/globalTypes'

import { Amount, isAmount } from './Amount'

import planFragmentRawString from '../PlanFragment.graphql'

export const planFragmentString = planFragmentRawString

export type PlanFragment = {
  id: string
  title: string
  subtitle: Maybe<string>
  cardCost: number
  bulkCardCost: number
  price: Amount
  description: Maybe<string>
  isAddon: boolean
}

export const isPlanFragment = (fragment: any): fragment is PlanFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  (fragment.subtitle === null || typeof fragment.subtitle === 'string') &&
  typeof fragment.cardCost === 'number' &&
  typeof fragment.bulkCardCost === 'number' &&
  (isAmount(fragment.price) as boolean) &&
  (fragment.description === null || typeof fragment.description === 'string') &&
  typeof fragment.isAddon === 'boolean'
